// extracted by mini-css-extract-plugin
export var decorateLeft = "icon-module--decorateLeft--rTC0X";
export var decorateRight = "icon-module--decorateRight--RRg86";
export var fadeInUp = "icon-module--fadeInUp--Pobug";
export var lGroup1 = "icon-module--lGroup1--JSfRo";
export var lGroup2 = "icon-module--lGroup2--4SQRF";
export var lGroup3 = "icon-module--lGroup3--LeiMm";
export var lGroup4 = "icon-module--lGroup4--Liquu";
export var lGroup5 = "icon-module--lGroup5--+ztdz";
export var lGroup6 = "icon-module--lGroup6--DBlqk";
export var lGroup7 = "icon-module--lGroup7--4SPiC";
export var lGroup8 = "icon-module--lGroup8--FZ+3W";
export var lGroup9 = "icon-module--lGroup9--twK5U";
export var leftFrameContainer = "icon-module--leftFrameContainer--BIO1F";
export var rGroup1 = "icon-module--rGroup1--5lws7";
export var rGroup2 = "icon-module--rGroup2--UksBe";
export var rGroup3 = "icon-module--rGroup3--gTNJ3";
export var rGroup4 = "icon-module--rGroup4--Kw0mL";
export var rGroup5 = "icon-module--rGroup5--UFnZP";
export var rGroup6 = "icon-module--rGroup6--NPo1k";
export var rGroup7 = "icon-module--rGroup7--BDQFv";
export var rGroup8 = "icon-module--rGroup8--x6uYc";
export var rGroup9 = "icon-module--rGroup9--IMD6P";
export var rightFrameContainer = "icon-module--rightFrameContainer--lvSZF";
export var sbShowMain = "icon-module--sb-show-main--cev4O";
export var zoomIn = "icon-module--zoomIn--O596+";